import {
  TimelineItem,
  Paragraph,
  AdvancedDialog,
  HelperText,
} from '@yaradigitallabs/ahua-react';

interface GuidelineDialogProps {
  title: string;
  colorConcept?: string;
  icon?: string;
  iconSize?: 'xs' | 's' | 'm' | 'l';
  triggerTitle?: string;
  content: React.ReactNode;
  helperText?: React.ReactNode;
}

export const GuidelineDialog = ({
  title,
  colorConcept = 'brand',
  icon = 'Info',
  iconSize = 'xs',
  triggerTitle = '',
  content,
  helperText,
}: GuidelineDialogProps) => {
  return (
    <AdvancedDialog>
      <AdvancedDialog.Trigger asChild>
        <TimelineItem>
          <TimelineItem.IconButton
            colorConcept={colorConcept}
            icon={icon}
            size={iconSize}
            title={triggerTitle || title}
          />
        </TimelineItem>
      </AdvancedDialog.Trigger>
      <AdvancedDialog.Content
        orientation="vertical"
        size="responsive"
        style={{ padding: '16px' }}
      >
        <AdvancedDialog.Start>
          <AdvancedDialog.Title>{title}</AdvancedDialog.Title>
          <AdvancedDialog.Close>
            <TimelineItem.IconButton
              colorConcept="brand"
              icon="Close"
              size="xs"
            />
          </AdvancedDialog.Close>
        </AdvancedDialog.Start>
        <AdvancedDialog.Middle orientation="vertical" size="responsive">
          <Paragraph size="s">{content}</Paragraph>
        </AdvancedDialog.Middle>
        {helperText && (
          <AdvancedDialog.End
            style={{
              justifyContent: 'flex-start',
            }}
          >
            <HelperText colorConcept="neutral" icon="Info">
              {helperText}
            </HelperText>
          </AdvancedDialog.End>
        )}
      </AdvancedDialog.Content>
    </AdvancedDialog>
  );
};
